module.exports = __webpack_public_path__ + "3ebe1b884236231611c25dafd9a5d2e5.png";